var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { id: "contents" } }, [
      _c("div", { staticClass: "contents_wrap" }, [
        _c("div", { staticClass: "landing_item" }, [
          _c("h2", { staticClass: "pg_title" }, [_vm._v("Access Denied")]),
          _vm._v(" "),
          _c("p", [
            _c("em", [_vm._v("You are not allowed to access the page.")]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn_blue",
                attrs: { href: "javascript:", title: "" },
                on: { click: _vm.goHome }
              },
              [_vm._v("Go Home")]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aee6dee8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aee6dee8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/certificate/CertAccessDenied.vue
// module id = 1NNW
// module chunks = 0